// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_5eGps","title-wrapper":"_3aBL6"};